module.exports = __webpack_public_path__ + "mainassets/img/tile-2-3.0ae056b5.jpg";